export const getCSSProp = (prop?: string) => prop || 'auto';
